module.exports = __webpack_public_path__ + "static/media/Layer3.f4d0fc55.png";